module.exports = __webpack_public_path__ + "static/media/me.98746127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/AboutSection/me.jpg
// module id = 207
// module chunks = 5